const axios = require('@/utils/axios')
const {baseURL} = require('@/assets/js/config')
const $http = axios.create({
	baseURL
})

const state = {
	schoolTeachers : [],
	schoolStudents:[],
    schoolUser:    {
        name:null,
        email:null,
        mobile:null,
        type:null,
        password:null
    },
	schoolDetails:{

	}
}

const getters = {
	fetchSchoolTeachers : (state) => state.schoolTeachers,
	fetchSchoolStudents : (state) => state.schoolStudents,
	fetchSchoolDetails : (state) => state.schoolDetails
}

const actions = {
	loadSchoolUsers({commit}, {token, type}){
		return $http.get(`user?type=${type}`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			if(type=="P")	
				commit('SET_SCHOOL_STUDENTS', response.data.data)
			else
				commit('SET_SCHOOL_TEACHERS', response.data.data)
			
		})
	},
	loadSchoolDetails({commit}, {token, id}){
		return $http.get(`school/${id}`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
				console.log(reponse.data.data)
				commit('SET_SCHOOL_DETAILS', response.data.data)
		})
	},
	createSchoolUser({commit}, {schoolUser, token}){
		
		for(let key in schoolUser){
			if(schoolUser[key] == null){
				delete schoolUser[key]
			}
		}
		
		return $http.post('user/school', schoolUser, {
			headers : {
				// 'Content-Type' : 'undefined',
				'x-auth-token' : token
			}
		}).then((response) => {
			if(response.data.data.type=="P")
				commit('ADD_SCHOOL_STUDENT', response.data.data)
			else if(response.data.data.type=="ST")
				commit('ADD_SCHOOL_TEACHER', response.data.data)
			
			return response.data
		})
	},
	
    // updateTeacher({commit}, {id, teacher, token}){
	// 	// let category_formdata = new FormData()
	// 	// for(let key in category){
	// 	// 	if(key == 'categoryfiles'){
	// 	// 		for(let i in category[key]){
	// 	// 			category_formdata.append(`${key}`, category[key][i])
	// 	// 		}
	// 	// 	}else if(key == 'editfiles'){
	// 	// 		category_formdata.append(key, JSON.stringify(category[key]))
	// 	// 	}else{
	// 	// 		category_formdata.append(key, category[key])
	// 	// 	}	
	// 	// }

	// 	for(let key in teacher){
	// 		if(teacher[key] == null){
	// 			delete teacher[key]
	// 		}
	// 	}
		
	// 	return $http.put(`user/${id}`, teacher, {
	// 		headers : {
	// 			// 'Content-Type' : 'undefined',
	// 			'x-auth-token' : token
	// 		}
	// 	}).then((response) => {
	// 		commit('UPDATE_TEACHER', response.data)
	// 	})
	// },

	// deleteTeacher({commit}, {id, token}){
	// 	return $http.delete(`user/${id}`, {
	// 		headers : {
	// 			'x-auth-token' : token
	// 		} 
	// 	}).then(() => {
	// 		commit('REMOVE_TEACHER', id)	
	// 	})
	// },
}

const mutations = {
	SET_SCHOOL_STUDENTS : (state, schoolStudents) => {
		state.schoolStudents = schoolStudents
	},
	SET_SCHOOL_TEACHERS : (state, schoolTeachers) => {
		state.schoolTeachers = schoolTeachers
	},
	ADD_SCHOOL_STUDENT : (state, schoolUser) => {
		state.schoolStudents.push(schoolUser)
	},
	ADD_SCHOOL_TEACHER : (state, schoolUser) => {
		state.schoolTeachers.push(schoolUser)
	},
	SET_SCHOOL_DETAILS : (state, schoolDetails) => {
		state.schoolDetails.push(schoolDetails)
	},
	// UPDATE_CATEGORY : (state, category) => {
	// 	state.current_category = category
	// 	let cat_index = state.categories.findIndex(category_obj => category_obj._id == category._id)
	// 	Vue.set(state.categories, cat_index, Object.assign({}, category)) // For making it reactive
	// },
	// REMOVE_CATEGORY : (state, category_id) => {
	// 	state.categories = state.categories.filter(category => category._id != category_id)
	// 	if(state.current_category && (state.current_category._id == category_id)){
	// 		state.current_category = null
	// 	}
	// },
}

export default {
	state, getters, actions, mutations
}